import {createReducer} from 'redux-act';
// @ts-ignore
import * as ramda from 'ramda';

import type {SavedFilter, SavedReportType, SavedListType, SavedFilterId} from '../types';
import {indexById} from '../utils/index-by-id';

import * as actions from './saved-filters-actions';
import {isSavedReport, isSavedList} from './saved-filters-utils';

export type SavedFiltersModuleState = {
    savedFilters: SavedFiltersState;
};

export type SavedFiltersState = {
    items: Partial<Record<SavedFilterId, SavedFilter<any>>>;
    isLoading: boolean;
    isSavingNew: boolean;
    isSavingSharePreferences: boolean;
    isResaving: boolean;
    loadingErrorMessage?: string;
    actionErrorMessage?: string;
};

const defaultState = {
    items: {},
    isLoading: true,
    isSavingNew: false,
    isSavingSharePreferences: false,
    isResaving: false,
    loadingErrorMessage: undefined,
    actionErrorMessage: undefined,
} as const;

type Reducer = (arg1: SavedFiltersState | null | undefined, arg2: any) => SavedFiltersState;

// @ts-ignore
export const reducer: Reducer = createReducer(
    {
        // @ts-ignore
        [actions.requestSavedReports]: (state) => {
            return {...state, isLoading: true, loadingErrorMessage: undefined};
        },
        // @ts-ignore
        [actions.requestSavedLists]: (state) => {
            return {...state, isLoading: true, loadingErrorMessage: undefined};
        },
        // @ts-ignore
        [actions.replaceSavedReports]: (state, payload: SavedFilter<SavedReportType>[]) => {
            // @ts-ignore
            const prevNonReportItems = ramda.filter((item) => !isSavedReport(item), state.items);
            const newReportItems = indexById(payload);

            return {
                ...state,
                items: {...prevNonReportItems, ...newReportItems},
                loadingErrorMessage: undefined,
                isLoading: false,
            };
        },
        // @ts-ignore
        [actions.replaceSavedLists]: (state, payload: SavedFilter<SavedListType>[]) => {
            // @ts-ignore
            const prevNonListItems = ramda.filter((item) => !isSavedList(item), state.items);
            const newListItems = indexById(payload.concat(prevNonListItems));

            return {
                ...state,
                items: {...prevNonListItems, ...newListItems},
                loadingErrorMessage: undefined,
                isLoading: false,
            };
        },
        // @ts-ignore
        [actions.replaceSavedFilter]: (state, payload: SavedFilter<any>) => {
            return {...state, items: {...state.items, [payload.id]: payload}};
        },
        // @ts-ignore
        [actions.updateSavedFilters]: (state, payload: SavedFilter<any>[]) => {
            const newReports = indexById(payload);

            return {
                ...state,
                items: {...state.items, ...newReports},
                loadingErrorMessage: undefined,
                isLoading: false,
            };
        },
        // @ts-ignore
        [actions.failSavedFilters]: (state, payload) => {
            return {...state, loadingErrorMessage: payload, isLoading: false};
        },
        // @ts-ignore
        [actions.clearActionError]: (state) => {
            return {...state, actionErrorMessage: undefined};
        },
        // @ts-ignore
        [actions.requestSaveNewFilter]: (state) => {
            return {...state, isSavingNew: true, actionErrorMessage: undefined};
        },
        // @ts-ignore
        [actions.updateSaveNewFilter]: (state) => {
            return {...state, isSavingNew: false, actionErrorMessage: undefined};
        },
        // @ts-ignore
        [actions.failSaveNewFilter]: (state) => {
            return {...state, isSavingNew: false, actionErrorMessage: 'Failed to save report'};
        },
        // @ts-ignore
        [actions.requestSaveSharePreferences]: (state) => {
            return {...state, isSavingSharePreferences: true, actionErrorMessage: undefined};
        },
        // @ts-ignore
        [actions.updateSaveSharePreferences]: (state) => {
            return {...state, isSavingSharePreferences: false};
        },
        // @ts-ignore
        [actions.failSaveSharePreferences]: (state) => {
            return {...state, actionErrorMessage: 'Failed to update report'};
        },
        // @ts-ignore
        [actions.requestResaveFilter]: (state) => {
            return {...state, isResaving: true, actionErrorMessage: undefined};
        },
        // @ts-ignore
        [actions.updateResaveFilter]: (state) => {
            return {...state, isResaving: false};
        },
        // @ts-ignore
        [actions.failResaveFilter]: (state) => {
            return {...state, actionErrorMessage: 'Failed to update report'};
        },
        // @ts-ignore
        [actions.requestDeleteSavedFilter]: (state) => {
            return {...state, actionErrorMessage: undefined};
        },
        // @ts-ignore
        [actions.failDeleteSavedFilter]: (state, payload) => {
            return {...state, actionErrorMessage: `Failed to delete: ${payload.name}`};
        },
        // @ts-ignore
        [actions.removeSavedFilter]: (state, id) => {
            const newItems = ramda.omit([id], state.items);

            return {...state, items: newItems};
        },
        'persist/REHYDRATE': (state, persistedState) => {
            if (!persistedState || !persistedState.savedFilters) {
                return state;
            }

            return {...state, ...defaultState, items: persistedState.savedFilters.items};
        },
    },
    defaultState
);
